<template>
  <div class="background" ref="card">
    <div style="float: left; padding-top: 150px;padding-left: 200px">
      <img :src=" loginpd" width="600" @click="backIndex" />
    </div>
    <a-card class="card">
      <div>
        <!--div style="text-align: center; padding-top: 16px">
          <img :src="logo" width="100" style="cursor: pointer; margin-top: 16px" @click="backIndex" />
        </div-->
        <div class="title" style="margin-top: 16px">
          <span style="cursor: pointer; font-size: 24px" @click="backIndex">汇量化助手</span>
        </div>
        <div style="text-align: center; font-size: 16px; color: #1890ff; margin-top: 8px; margin-bottom: 24px">
          <span>智能化股票量化云管理平台</span>
        </div>
      </div>
      <router-view />
    </a-card>
  </div>
</template>

<script>
export default {
  name: "UserLayout",
  data () {
    return {
      logo: require("@/assets/logo.png"),
      loginpd: require("@/assets/login-pd.8634e0d5.png"),

    };
  },
  methods: {
    backIndex () {
      window.open("http://www.728data.com", "_self");
    },
  },
};
</script>

<style scoped>
.card {
  width: 440px;
  border-radius: 8px;
  padding-bottom: 32px;
  margin-top: 100px !important;
  margin-right: 180px !important;
  float: right;
}

.background {
  min-height: 100%;
  padding: 10vh 0;
  background: #37a1ef url("~@/assets/background.svg") no-repeat 50%;
}

.title {
  text-align: center;
  font-size: 32px;
  color: #1890ff;
  margin-top: 8px;
  font-weight: bold;
}
</style>
